import { Close } from '@mui/icons-material'
import { IconButton } from '@mui/material'
import { SimpleShowLayout, TextField } from 'ra-ui-materialui'
import React from 'react'
import { DateField, NumberField, RecordContextProvider } from 'react-admin'
import {
  Transaction,
  TransactionService,
} from 'services/api/entities/accounting/transaction/types/internal/transaction-models'
import { getGeoLang } from 'services/geo-management'
import { getDiscountedPrice } from 'services/utils/prices'

type Props = {
  record?: Transaction
  handleClose: () => void
}

const TransactionAsidePanel: React.FC<Props> = ({ record, handleClose }) => {
  const price =
    record?.services.reduce(
      (acc: number, { price }: TransactionService) => acc + price,
      0
    ) ?? 0

  const discountedPrice = getDiscountedPrice(price, record?.discountPerc ?? 0)

  const discount = price - discountedPrice

  const enrichedRecord = { ...record, price, discountedPrice, discount }

  return (
    <RecordContextProvider value={enrichedRecord}>
      <SimpleShowLayout>
        <IconButton onClick={handleClose} style={{ marginTop: '48px' }}>
          <Close />
        </IconButton>
        <TextField source="id" label="form.fields.eventId" />
        <TextField source="customerName" />
        <TextField source="customerEmail" />
        <DateField
          source="eventDate"
          label="form.fields.eventDate"
          locales={getGeoLang()}
        />
        <TextField source="eventType" />

        <NumberField source="price" />
        <NumberField source="discount" />
        <NumberField source="discountedPrice" />
      </SimpleShowLayout>
    </RecordContextProvider>
  )
}

export default TransactionAsidePanel
